<template>
	<div class="login">
		<h3>Cloud Admin Login</h3>
		<input name="username" class="textInput" placeholder="username" v-model="username" />

		<br />

		<input class="textInput" placeholder="password" type="password" v-model="password" v-on:keyup.enter="submit" />

		<br />

		<button @click.prevent="submit" class="loginButton">Login</button>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data: function() {
		return {
			username: null,
			password: null
		}
	},
	mounted: function() {},
	methods: {
		submit: async function() {
			if (this.username === null || this.password === null) {
				this.$buefy.toast.open({
					message: 'Both fields are required',
					type: 'is-danger',
					position: 'is-top'
				})
			} else {
				this.userLogin()
			}
		},
		userLogin: async function() {
			const userLogin = await this.$api.login({
				username: this.username,
				password: this.password
			})

			if (userLogin) {
				this.$buefy.toast.open({
					message: 'Login Successful!',
					type: 'is-success',
					position: 'is-top'
				})

				this.$axios.defaults.headers.common['Authorization'] = 'Token ' + userLogin.data.staffs_authToken

				// Save in x
				this.$store.dispatch('set_auth', userLogin.data.staffs_authToken)

				this.$router.push({ name: 'dashboard' })
			} else {
				// Display message if failed to login
				this.$buefy.toast.open({
					message: 'Invalid Login',
					type: 'is-danger',
					position: 'is-top'
				})
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/Login.css';
</style>
